import React from 'react';
import { Button, CircularProgress } from '@nextiva/next-ui-components';
import PropTypes from 'prop-types';

const DrawerFooter = ({
  cancelOnClick,
  cancelText,
  saveOnClick,
  saveText,
  saveEnabled,
  cancelEnabled,
  hideSave,
  hideDelete,
  hideCancel,
  deleteEnabled,
  deleteOnClick,
  deleteText,
  showSpinner,
}) => {
  return (
    <div className="m-chime-drawer__footer">
      <div className="content">
        {!hideCancel && (
          <div className="button-item">
            <Button
              className="drawerButton"
              id="locationDrawerCancelBtn"
              type="button"
              color="secondary"
              variant="contained"
              onClick={cancelOnClick}
              disabled={!cancelEnabled}
              data-testid="PlatformAdminUI-ChimeDrawer-CancelButton"
            >
              {cancelText}
            </Button>
          </div>
        )}
        {!hideSave && (
          <div className="button-item">
            <Button
              className="drawerButton"
              id="locationDrawerSaveBtn"
              type="button"
              color="primary"
              variant="contained"
              onClick={saveOnClick}
              disabled={!saveEnabled}
              data-testid="PlatformAdminUI-ChimeDrawer-SaveButton"
            >
              {saveText}
            </Button>
            {showSpinner && (
              <div className="m-drawer-footer__container__action-bar__spinner">
                <CircularProgress
                  style={{ color: '#009FE0' }}
                  variant="indeterminate"
                  size={36}
                />
              </div>
            )}
          </div>
        )}
        {!hideDelete && (
          <div className="button-item">
            <div className="deleteContainer">
              <span
                disabled={deleteEnabled}
                role="presentation"
                onClick={deleteOnClick}
                className="deleteButton Body-Emphasis"
                data-testid="PlatformAdminUI-ChimeDrawer-DeleteButton"
              >
                {deleteText}
              </span>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

DrawerFooter.propTypes = {
  cancelEnabled: PropTypes.bool,
  cancelOnClick: PropTypes.func,
  cancelText: PropTypes.string,
  deleteEnabled: PropTypes.bool,
  deleteOnClick: PropTypes.func,
  deleteText: PropTypes.string,
  hideCancel: PropTypes.bool,
  hideDelete: PropTypes.bool,
  hideSave: PropTypes.bool,
  saveEnabled: PropTypes.bool,
  saveOnClick: PropTypes.func,
  saveText: PropTypes.string,
  showSpinner: PropTypes.bool,
};

DrawerFooter.defaultProps = {
  cancelOnClick: () => {},
  cancelText: 'Cancel',
  saveOnClick: () => {},
  saveText: 'Save',
  deleteText: 'Delete',
  deleteEnabled: true,
  deleteOnClick: () => {},
  hideSave: false,
  saveEnabled: true,
  hideCancel: false,
  cancelEnabled: true,
  hideDelete: true,
  showSpinner: false,
};

export default DrawerFooter;
